<div *ngIf="isLoading | async" class="min-h-24">
  <img src="assets/loader.svg" class="d-block ml-auto mr-auto" alt="spinner">
  <br>Loading...
</div>
